import React from "react";
import { InlineMath, BlockMath } from "react-katex";

/**
 * Renders a string that may contain LaTeX math wrapped in $...$ (inline)
 * or $$...$$ (display). Falls back to plain text for the rest.
 * Also silently ignores render errors so a bad expression doesn't crash the UI.
 */
export default function Math({ children, className = "" }) {
  const text = String(children ?? "");
  const parts = text.split(/(\$\$[^$]+\$\$|\$[^$\n]+\$)/g);
  return (
    <span className={className}>
      {parts.map((p, i) => {
        try {
          if (p.startsWith("$$") && p.endsWith("$$") && p.length > 4) {
            return <BlockMath key={i} math={p.slice(2, -2)} />;
          }
          if (p.startsWith("$") && p.endsWith("$") && p.length > 2) {
            return <InlineMath key={i} math={p.slice(1, -1)} />;
          }
        } catch {
          return <span key={i}>{p}</span>;
        }
        return <span key={i}>{p}</span>;
      })}
    </span>
  );
}
